import type { MapMarkerData } from '~/components/map';
import type { TripOverviewItem } from '~/services/engine-ts';
import { tripOverviewToMapData } from '../lib/tripOverviewToMapData';

const stayItemId = (item: TripOverviewItem | undefined) => (item?.type === 'stay' ? item.itemId : undefined);

export const tripStaysToMapData = (items: TripOverviewItem[]) => {
  const mapData = tripOverviewToMapData(items);
  const boundaryStayIds: Record<string, number | undefined> = {
    origin: stayItemId(items[0]),
    destination: stayItemId(items.at(-1))
  };
  const stayProgress = items.flatMap((item) =>
    item.type === 'stay' ? [mapData.itemIdToProgress.get(item.itemId) ?? 0] : []
  );

  const toRouteProgress = (listProgress: number) => {
    if (stayProgress.length < 2) return stayProgress[0] ?? listProgress;
    const position = listProgress * (stayProgress.length - 1);
    const index = Math.min(Math.floor(position), stayProgress.length - 2);
    return stayProgress[index] + (stayProgress[index + 1] - stayProgress[index]) * (position - index);
  };

  const markers = mapData.markers.map((marker) => {
    const itemId = boundaryStayIds[marker.id];
    return itemId === undefined ? marker : { ...marker, id: `stay-${itemId}` };
  });
  const markerIds = new Set(markers.map((marker) => marker.id));
  const absorbedStayMarkers = items.flatMap((item): MapMarkerData[] =>
    item.type === 'stay' && !markerIds.has(`stay-${item.itemId}`)
      ? [
          {
            id: `stay-${item.itemId}`,
            icon: 'bed',
            position: 'middle',
            coordinates: item.place.geoCoordinates,
            label: item.place.name,
            progressAt: mapData.itemIdToProgress.get(item.itemId) ?? 0
          }
        ]
      : []
  );

  return {
    ...mapData,
    markers: [...markers, ...absorbedStayMarkers],
    toRouteProgress
  };
};
